export default {"src":"/_next/static/media/Twitter.ecc063fd.svg","height":37,"width":37,"blurWidth":0,"blurHeight":0};